import { FrontEndConfiguration } from '@/types';
import { MenuMode } from '@ygtechnologies/rubus-ui';

export const setUser = (data) => ({
    type: 'SET_GLOBAL_USER',
    data,
});

export const setActiveProfile = (data) => ({
    type: 'SET_GLOBAL_ACTIVE_PROFILE',
    data,
});

export const setActiveProject = (data) => ({
    type: 'SET_GLOBAL_ACTIVE_PROJECT',
    data,
});

// export const setCategories = (data) => ({
//     type: 'SET_GLOBAL_CATEGORIES',
//     data,
// });

export const setProfiles = (data) => ({
    type: 'SET_GLOBAL_PROFILES',
    data,
});
export const setWindowWidth = (data: number) => ({
    type: 'SET_WINDOW_WIDTH',
    data,
});

export const setConfiguration = (data: FrontEndConfiguration) => ({
    type: 'SET_GLOBAL_CONFIGURATION',
    data,
});

export const setCanScroll = (data: boolean) => ({
    type: 'SET_GLOBAL_CAN_SCROLL',
    data,
});

export const setSidebarMode = (data: MenuMode) => ({
    type: 'SET_GLOBAL_SIDEBAR_MODE',
    data,
});
